export default function ArrowSquareDown() {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.00065 15.1663H10.0007C13.334 15.1663 14.6673 13.833 14.6673 10.4997V6.49967C14.6673 3.16634 13.334 1.83301 10.0007 1.83301H6.00065C2.66732 1.83301 1.33398 3.16634 1.33398 6.49967V10.4997C1.33398 13.833 2.66732 15.1663 6.00065 15.1663Z'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.64648 7.59375L7.99982 9.94042L10.3532 7.59375'
        stroke='currentColor'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
